import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { LocalStorageService } from 'ngx-webstorage';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../services/common.service';
import { DtoService } from '../../services/dto.service';
import { FunctService } from '../../services/funct.service';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-sport-dialog',
  templateUrl: './sport-dialog.component.html',
  styleUrls: ['./sport-dialog.component.scss']
})

export class SportDialogComponent implements OnInit {

  title: string;
  closeBtnName: string; 
  @Input() data: any=[];  
  play_free: any;
  show_transfer: boolean = false;
  launchTagName: any;
  token: any;
  launchGameResModel: any;
  isSafari: boolean;

  constructor(
    private toastr: ToastrService,
    private http: HttpClient,
    private spinner: NgxSpinnerService,
    private dto: DtoService, 
    private route: ActivatedRoute, 
    private funct: FunctService,
    private storage: LocalStorageService,
    public bsModalRef: BsModalRef,
    private translateService: TranslateService,
    private router: Router,
    public common: CommonService) {
   
  } 

  ngOnInit() {
    this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (this.isSafari) {
      
      var IsSafari=this.storage.retrieve('localIsSafari');
      if (IsSafari != null && IsSafari != undefined && IsSafari != "") {
        window.location.reload();
        this.storage.clear('localIsSafari');        
        return;
      }
      
    }

    if(parseInt(this.data.gameBalance) < 1000){
      this.show_transfer=true;
    }    
    this.play_free = this.translateService.instant('show-sport');
    this.closeBtnName = this.translateService.instant('cancel');    
  }

  close() {
    this.bsModalRef.hide();
  }

  handleError(error: HttpErrorResponse) {
   
    if (error.status == 0) {
      this.common.errorMsg("", "checkInternet", "top");
      return;
    } else if(error.status == 423 || error.status== 417) {
      this.common.errorMsg("", "youNeedLogin", "top");
      this.storage.clear('token');
      this.storage.clear('isUserLoggedIn');
      return;
    } else if (error.status == 400) {
      this.common.errorMsg("", "bad_request", "top");
      return;
    } else {
      this.common.errorMsg("", "server_error", "top");
      return;
    }
  
  }

  goToPlay() {
    this.bsModalRef.hide();
    this.launchGame();
  }

  launchGame() {

    let token = this.storage.retrieve('token');
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', token);

    this.http.post(this.funct.ipaddress + 'loginGS/launchGames', this.data.launchGameModel, {headers: headers })
    .pipe (
      catchError(this.handleError.bind(this))
    )
    .subscribe(
      async result => {
        this.dto.Response = {};
        this.dto.Response = result;
                 
        if (this.dto.Response.data != null || this.dto.Response.data != undefined) {
          this.launchGameResModel = this.dto.Response.data;
          this.spinner.hide("apiLoading");
          // this.gameUserBalance = await this.getGameUserBalance(); 
          this.storage.store('localPreviousRoute', 'gameList');
          sessionStorage.setItem('providerId', this.data.providerId);  
          localStorage.setItem("launchUrl", this.launchGameResModel.gameUrl); // play without money
          if(this.isSafari){
            this.storage.store('localIsSafari', 'isSafari');
            this.router.navigate(['/game/play'],{state: {launchUrl: this.launchGameResModel.gameUrl, providerId: this.data.providerId, parentLink : "/gameList/"+this.data.providerId}});  
            return;        
          } 
          else{
            this.router.navigate(['/game/play'],{state: {launchUrl: this.launchGameResModel.gameUrl, providerId: this.data.providerId, parentLink : "/gameList/"+this.data.providerId}});     
            return;     
          }
        }

    });
  }

  goToWallet() {
    this.bsModalRef.hide();
    sessionStorage.setItem('gameProviderId', "ProviderId");
    this.storage.store("localAutoLaunchGame", this.data.launchGameModel);
    this.router.navigate(['/game/wallet'], {state: {selectGameAccount: this.data.providerId, parentLink: "/gameList/"+this.data.providerId},replaceUrl: false})
  }

}